import { ProfileCard } from 'components/profileCards';
import styled from 'styled-components';
import { PageCSS, StyledTypography } from 'styles/common';

export const Container = styled.div`
  height: 100%;
  position: relative;
  ${PageCSS};
`;

export const CardContainer = styled.div`
  height: ${(props) => props.height || '20vh'};
`;

export const Sidebar = styled.aside`
  position: fixed;
  // display: flex;
  overflow: hidden;
  height: 92vh;
`;

export const LeftSidebar = styled(Sidebar)`
  left: 3.5%;
  width: 22%;
  ${(props) => props.theme.breakpoints.up('sm')} {
    left: 3.5%;
    width: 22%;
  }
  ${(props) => props.theme.breakpoints.up('md')} {
    left: 4%;
    width: 20%;
  }
  ${(props) => props.theme.breakpoints.up('lg')} {
    // left: 6%;
    width: 21%;
  }
  ${(props) => props.theme.breakpoints.up('xl')} {
    left: 8.5%;
    width: 21%;
  }
`;

export const MainContent = styled.div`
  display: inline-block;
  position: relative;
  left: 26.5%;
  width: 65.5%;
  ${(props) => props.theme.breakpoints.up('sm')} {
    width: 68.5%;
  }

  ${(props) => props.theme.breakpoints.up('md')} {
    left: 26%;
    width: 67%;
  }

  ${(props) => props.theme.breakpoints.up('lg')} {
    left: 26.5%;
    width: 69.5%;
  }

  ${(props) => props.theme.breakpoints.up('xl')} {
    left: 30.5%;
    width: 60%;
  }
  height: 100%;
  vertical-align: top;
`;

export const HeaderContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: 24px;
  // height: 6vh;
  justify-content: space-between;
`;
export const Space = styled.div`
  width: 30.33%;
`;

export const Heading = styled(StyledTypography)`
  justify-self: center;
  width: 33.33%;
  // text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: first baseline;
`;

export const DurationDropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 36%;
  height: 100%;
  .settingsCircularIcon {
    display: inline-flex;
    align-items: center;
    padding-left: 1rem;
    padding-top: 4px;
    height: 100%;
    padding-right: 1rem;
    margin-right: -1rem;
  }
`;

export const StyledProfileCard = styled(ProfileCard)`
  // box-shadow: none;
`;

export const HomeFeedContainer = styled.div`
  margin-left: -1rem;
`;

export const TeamViewTypesContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const ViewTypesContainer = styled.div`
  display: flex;
  align-items: stretch;
`;

export const SettingsContainer = styled.div``;
